import ReportsTravelRuleTableItem from './ReportsTravelRuleTableItem'

export default ReportsTravelRuleTableItem
